// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"is-z","giftOrPromoSelector":"js-z","disabled":"ks-z","subTitle":"ls-z","selectShipAddressMessage":"ms-z","changePayment":"ns-z"};